import EmptyPlaceholder from './empty-placeholder';

export type { EmptyPlaceholderProps } from './empty-placeholder';
export default EmptyPlaceholder;
